"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Point_js_1 = __importDefault(require("ol/geom/Point.js"));
var layer_js_1 = require("ol/layer.js");
var source_js_1 = require("ol/source.js");
var style_js_1 = require("ol/style.js");
var Feature_js_1 = __importDefault(require("ol/Feature.js"));
var LineString_1 = __importDefault(require("ol/geom/LineString"));
var RouteLayer = /** @class */ (function () {
    function RouteLayer() {
        var self = this;
        var source = new source_js_1.Vector();
        var styleFunction = function (feature, resolution) {
            var geometry = feature.getGeometry();
            var styles = [
                // linestring
                new style_js_1.Style({
                    stroke: new style_js_1.Stroke({
                        color: '#666666',
                        width: 2,
                        lineDash: [3, 3]
                    })
                })
            ];
            return styles;
        };
        this.layer = new layer_js_1.Vector({
            source: source,
            style: styleFunction
        });
        this.layer.setZIndex(200);
    }
    RouteLayer.prototype.get = function () {
        return this.layer;
    };
    RouteLayer.prototype.getSource = function () {
        return this.layer.getSource();
    };
    RouteLayer.prototype.addFeature = function (data) {
        var feature_styles = [
            new style_js_1.Style({
                image: new style_js_1.Circle({
                    radius: 8,
                    fill: new style_js_1.Fill({ color: '#333333' }),
                    stroke: new style_js_1.Stroke({ color: '#333333', width: 1 })
                }),
                text: new style_js_1.Text({
                    text: data.id.toString(),
                    fill: new style_js_1.Fill({ color: '#FFFFFF' }),
                    stroke: new style_js_1.Stroke({
                        color: '#333333',
                        width: 3
                    })
                })
            })
        ];
        var feature = new Feature_js_1.default({
            geometry: new Point_js_1.default([0, 0])
        });
        feature.setStyle(feature_styles);
        this.layer.getSource().addFeature(feature);
        return feature;
    };
    RouteLayer.prototype.drawRoute = function (points) {
        var feature = new Feature_js_1.default({
            geometry: new LineString_1.default(points)
        });
        this.layer.getSource().addFeature(feature);
    };
    RouteLayer.prototype.setPosition = function (feature, position) {
        feature.getGeometry().setCoordinates(position);
    };
    RouteLayer.prototype.getExtent = function () {
        return this.layer.getSource().getExtent();
    };
    return RouteLayer;
}());
exports.default = RouteLayer;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/trips/classes/route.js
// module id = 384
// module chunks = 0